module.exports = __webpack_public_path__ + "img/play-solid.85f7f401.svg";